import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getFuel: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.FUEL].GET_FUEL,
	},
	getFuelPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.FUEL].GET_FUEL_PREVIEW,
	}
}
